import React, { useEffect, useState } from 'react'
import { PageLink, PageTitle } from '../../../../_metronic/layout/core'
import { useIntl } from 'react-intl'
import Functions from '../../../../setup/utilities/Functions'
import SalesTeamToolbar from './components/SalesTeamToolbar'
import SalesTeamListing from './components/SalesTeamListing'

const salesTeamBreadCrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
  {
    title: 'Gestion des equipes des commerciaux',
    path: '',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const SalesTeamWrapper: React.FC = () => {
  const intl = useIntl()
  const [show, setShow] = React.useState(false)
  const [action, setAction] = React.useState<string>('')
  const [salesTeam, setSalesTeam] = useState<ISalesTeam|undefined|null>(null)

  const handleClose = async (isSubmit: boolean) => {
    if (!isSubmit) {
      const isConfirmed = await Functions.sweetAlert(
        '<span class="mt-5">' + intl.formatMessage({ id: 'action.message' }) + '</span>',
        'warning',
        true,
        intl.formatMessage({ id: 'action.cancel' }),
        intl.formatMessage({ id: 'action.return' }),
        'btn btn-primary mt-10 mb-10',
        'btn btn-active-light mt-10 mb-10',
      )
      if (isConfirmed) {
        setShow(false)
      }
    } else {
      setShow(false)
    }
  }
  const handleShow = (salesTeam: ISalesTeam|undefined|null, action: string) => {
    setSalesTeam(salesTeam)
    setAction(action)
    setShow(true)
  }

  useEffect(() => {}, [salesTeam])

  return (
    <>
      <PageTitle breadcrumbs={salesTeamBreadCrumbs} pageTitle={intl.formatMessage({ id: 'salesTeam.list' })}>
        <SalesTeamToolbar handleShow={handleShow}/>
      </PageTitle>
      <SalesTeamListing handleShow={handleShow} handleClose={handleClose} show={show} salesTeamSelected={salesTeam} action={action}/>
    </>
  )
}

export default SalesTeamWrapper
